import React, { useEffect, useState, useMemo } from 'react';
import { Checkbox, FormControlLabel, Grid, Chip, Avatar, Tooltip } from '@material-ui/core';
import { Link as LinkIcon } from '@material-ui/icons';
import ReactDOM from 'react-dom';
import ManageAccountGrid from '../../../managementAccount/manageAccountGrid';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import DialogComp from '../../../../Core/Controls/Dialog/DialogComp';
import MappingSubModal from '../NominalMapping/mappingSubModal';
import NominalCategoryAddEditModal from './categoryEditModal';
import NominalBudget from './NominalBudget.jsx';
import AddIcon from '@material-ui/icons/Add';
import ImportBudget from './importBudget.jsx';
import { getMANominalAccount_UsedList } from '../../../../Core/Service/ManageAccount/NominalBudget-Modal-Service.js';
import { set } from 'lodash';
import UsedNominalAccountTable from './usedTable.jsx';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Management Accounts', active: true },
    { name: 'Nominal Account Codes', active: true }
];

const basecolumns = [
    { field: 'accountCode', title: 'Account Code', width: 150 },
    { field: 'branch', title: 'Branch', width: 90 },
    { field: 'branchName', title: 'Branch Name' },
    { field: 'department', title: 'Department', width: 100 },
    { field: 'departmentName', title: 'Department Name' },
    { field: 'model', title: 'Model', width: 80 },
    { field: 'modelName', title: 'Model Name' },
    { field: 'used', title: 'Used', width: 80 }
    // { field: 'expenseCategory', title: 'Expense Category', width: 130 },
    // { field: 'expenseCategoryName', title: 'Expense Category Name' },
    // { field: 'maMappingCategoryID', title: 'Category', width: 100 },
    // { field: 'maMappingCategoryName', title: 'Category Name' }
];

const positionMapping = {
    1: { key: 'branch', description: 'Branch' },
    2: { key: 'department', description: 'Department' },
    4: { key: 'model', description: 'Model' },
    5: { key: 'expenseCategory', description: 'Expense Category' }
};

function NominalAccountCodes(props) {
    const [state, setState] = useState({
        open: false,
        positionID: '',
        mappingValue: '',
        IsEmptyBranch: false,
        IsEmptyDepartment: false,
        IsEmptyModel: false,
        IsEmptyExpenseCategory: false,
        IsEmptyCategory: false,
        showAccCodeModal: false,
        UsedCodeList: [],
        showUsedCode: false,
        AccountCode: ''
    });

    const addBtnClicked = (positionID, record) => {
        const mapping = positionMapping[positionID];
        if (!mapping) return;

        const mappingValue = record[mapping.key];
        const mappingValueDescription = mapping.description;

        setState((st) => ({
            ...st,
            showMappingModal: true,
            selectedRowData: record,
            positionID: positionID,
            mappingValue,
            mappingValueDescription
        }));
    };

    const editButton = (positionID) => (value, record) => {
        const mapping = positionMapping[positionID];
        if (!mapping) return value;

        const spn = document.createElement('span');
        const lnk = (
            <Grid container>
                {record[mapping.key] && !value ? <LinkIcon onClick={() => addBtnClicked(positionID, record)} style={{ cursor: 'pointer' }} /> : value}
            </Grid>
        );

        ReactDOM.render(lnk, spn);
        return spn;
    };

    const editCategoryButton = (value, record) => {
        const spn = document.createElement('span');
        const lnk = <Grid container>{!value ? <LinkIcon onClick={() => addBtnCategoryClicked(record)} style={{ cursor: 'pointer' }} /> : value}</Grid>;
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const handleUsedButton = async (row) => {
        try {
            let res = await getMANominalAccount_UsedList(row.accountCode);
            if (res.success) {
                setState((st) => ({
                    ...st,
                    showUsedCode: true,
                    UsedCodeList: res.data.list || [],
                    AccountCode: row.accountCode
                }));
            }
        } catch (error) {
            console.error('Error fetching used codes:', error);
        }
    };

    const handleUsed = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container alignItems="center">
                <div
                    style={{
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        textDecoration: 'underline'
                    }}
                    onClick={() => handleUsedButton(record)}
                >
                    {value}
                </div>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const AccCodeColumnWrapper = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container alignItems="center">
                <div
                    style={{
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        textDecoration: 'underline'
                    }}
                    onClick={() => handleAccModal(record)}
                >
                    {value}
                </div>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...basecolumns];

        let colAccCode = tempCols.find((m) => m.field === 'accountCode');
        if (colAccCode) {
            colAccCode.renderer = AccCodeColumnWrapper;
        }
        let colUsed = tempCols.find((m) => m.field === 'used');
        if (colUsed) {
            colUsed.renderer = handleUsed;
        }

        Object.keys(positionMapping).forEach((positionID) => {
            const { key } = positionMapping[positionID];
            const column = tempCols.find((col) => col.field === `${key}Name`);
            if (column) {
                column.renderer = editButton(Number(positionID));
            }
        });

        let CategoryCol = tempCols.find((e) => e.field === 'maMappingCategoryName');
        if (CategoryCol) {
            CategoryCol.renderer = editCategoryButton;
        }
        return tempCols;
    }, []);

    const addBtnCategoryClicked = (record, ac) => {
        setState((st) => ({
            ...st,
            showCategoryModal: true,
            selectedRowData: record
        }));
    };

    const handleAccModal = (record) => {
        setState((st) => ({
            ...st,
            showAccCodeModal: true,
            selectedRowData: record
        }));
    };

    const handleImportBudget = (record) => {
        setState((st) => ({
            ...st,
            showImportBudget: true
        }));
    };
    const handleClose = () => {
        setState((st) => ({
            ...st,

            showImportBudget: false,
            showUsedCode: false
        }));
    };
    const pullBudgetAndUpdateState = async () => {
        setState((st) => ({
            ...st,
            isReload: new Date(),
            showImportBudget: false
        }));
    };
    const closeDialog = (isReload) => {
        let newSt = {};
        newSt.showMappingModal = false;
        newSt.showCategoryModal = false;
        newSt.showAccCodeModal = false;

        if (isReload) {
            newSt.isReload = new Date();
        }
        setState((st) => ({
            ...st,
            ...newSt
        }));
    };

    const handleCheckbox = (event) => {
        const { name, checked } = event.target;
        setState((st) => {
            const nst = { ...st };
            nst[name] = checked;
            return nst;
        });
    };

    return (
        <div className="screen">
            <Grid container alignItems="center">
                <Grid item>
                    <BreadCrumbs crumbs={crumbs} />
                </Grid>
                <Grid item>
                    <FormControlLabel control={<Checkbox checked={state.IsEmptyBranch} onChange={handleCheckbox} name="IsEmptyBranch" />} label="Branch" />
                </Grid>
                <Grid item>
                    <FormControlLabel
                        control={<Checkbox checked={state.IsEmptyDepartment} onChange={handleCheckbox} name="IsEmptyDepartment" />}
                        label="Department"
                    />
                </Grid>
                <Grid item>
                    <FormControlLabel control={<Checkbox checked={state.IsEmptyModel} onChange={handleCheckbox} name="IsEmptyModel" />} label="Model" />
                </Grid>
                <Grid item>
                    <FormControlLabel
                        control={<Checkbox checked={state.IsEmptyExpenseCategory} onChange={handleCheckbox} name="IsEmptyExpenseCategory" />}
                        label="Expense Category"
                    />
                </Grid>
                <Grid item>
                    <FormControlLabel
                        control={<Checkbox checked={state.IsEmptyCategory} onChange={handleCheckbox} name="IsEmptyCategory" />}
                        label="Category"
                    />
                </Grid>
                <Grid item>
                    <Chip
                        label="Import Budget"
                        onClick={handleImportBudget}
                        avatar={
                            <Avatar>
                                <Tooltip title="Import Budget">
                                    <AddIcon />
                                </Tooltip>
                            </Avatar>
                        }
                        style={{ fontWeight: 'bold' }}
                    ></Chip>
                </Grid>
            </Grid>
            <ManageAccountGrid
                dataConverter={(res) => ({
                    records: res.data.list,
                    total: res.data.total
                })}
                columns={columns}
                getUrl={`NominalCodes/GetNominalAccountCodes?IsEmptyBranch=${state.IsEmptyBranch}&IsEmptyDepartment=${state.IsEmptyDepartment}&IsEmptyModel=${state.IsEmptyModel}&IsEmptyExpenseCategory=${state.IsEmptyExpenseCategory}&IsEmptyCategory=${state.IsEmptyCategory}`}
                isReload={state.isReload}
            />
            {state.showMappingModal ? (
                <DialogComp
                    title={state.selectedRowData?.mappingValueID ? 'Update Mapping Data' : 'Add Mapping Data'}
                    onClose={() => closeDialog(false)}
                    maxWidth="sm"
                    fullWidth
                >
                    <MappingSubModal
                        onClose={closeDialog}
                        selectedRowData={state.selectedRowData}
                        maMappingPositionsID={state.positionID}
                        positionLength={'disabled'}
                        mappingValue={state.mappingValue}
                        mappingValueDescription={state.mappingValueDescription}
                    />
                </DialogComp>
            ) : null}
            {state.showCategoryModal ? (
                <DialogComp
                    title={state.selectedRowData?.mappingValueID ? 'Mapping Data' : 'Mapping Data'}
                    onClose={() => closeDialog(false)}
                    maxWidth="sm"
                    fullWidth
                >
                    <NominalCategoryAddEditModal onClose={closeDialog} selectedRowData={state.selectedRowData} mappingValue={state.mappingValue} />
                </DialogComp>
            ) : null}
            {state.showAccCodeModal ? (
                <DialogComp title="Budget" onClose={() => closeDialog(false)} maxWidth="xl" fullWidth>
                    <NominalBudget onClose={closeDialog} selectedRowData={state.selectedRowData} />
                </DialogComp>
            ) : null}
            {state.showImportBudget ? (
                <DialogComp open={true} onClose={handleClose} title={'Import Budget'} fullScreen>
                    <ImportBudget onSubmit={pullBudgetAndUpdateState} />
                </DialogComp>
            ) : null}
            {state.showUsedCode ? (
                <DialogComp open={true} onClose={handleClose} title={`Category Used - ${state.AccountCode}`} maxWidth="md" fullWidth>
                    <UsedNominalAccountTable List={state.UsedCodeList} />
                </DialogComp>
            ) : null}
        </div>
    );
}

export default NominalAccountCodes;
